import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/info',
    name: 'Info',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Info.vue')
  },
  {
    path: '/services',
    name: 'Services',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../components/Services.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Projects.vue'),
  },
  {
    path: '/projects/detail',
    name: 'ProjectDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../components/ProjectDetail.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/generalrules',
    component: () => import('../views/GeneralRules.vue')
  },
  {
    path: '/MailSignature/ccooobanner-2026-02.png',
    component: () => import('../views/MailSignature.vue')
  },
  {
    path: '/credits',
    component: () => import('../views/Credits.vue')
  },
  {
    path: '/robots.txt',
    component: () => import('../views/Robots.vue')
  },
  {
    path: '/sitemap.xml',
    component: () => import('../views/SiteMap.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/PageNotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
